/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Cash_Amount_InvalidInputs */

const vi_order_settlement_cash_amount_invalid = /** @type {(inputs: Order_Settlement_Cash_Amount_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền đã thu phải lớn hơn 0. Để trống nếu khách trả đủ`)
};

/**

* @param {Order_Settlement_Cash_Amount_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_cash_amount_invalid = /** @type {((inputs?: Order_Settlement_Cash_Amount_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Cash_Amount_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_cash_amount_invalid(inputs)
});